// service
import PurchaseBusinessService from '../../../purchase-business-service.js';
import { successMessage, errorMessage } from '@/utils/message.js';

export default {
  components: {
  },
  data() {
    return {
      statusType: [{code: 1, value: '通过'}, {code: 2, value: '不通过'}],
      auditApplyInfo: {},
      attachmentInfo: [],
      legalImgArr: [],
      assignorImgArr: [],
      form: {
        id: '',
        status: 1,
        reason: ''
      },
      rules: {
        status: [
          { required: true, message: '请选择资格意见', trigger: 'change' }
        ],
        reason: [
          { required: false, message: '请输入少于200字的备注信息', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.form.id = this.$route.query.id;
    this.status = this.$route.query.status || '';
    this.formPath = this.$route.query.formPath || '';
    console.log(this.formPath, 'this.formPath');
    this.getSignUserInfo();
  },
  watch: {
    'form.status'() {
      this.$refs['form'].clearValidate();
      this.form.reason = '';
      if (this.form.status === 2) {
        this.$set(this.rules.reason, 0, { required: true, message: '请输入少于200字的备注信息', trigger: 'blur' });
      } else {
        this.$set(this.rules.reason, 0, { required: false, message: '请输入少于200字的备注信息', trigger: 'blur' });
      }
    }
  },
  methods: {
    // 审批
    approveSignQualification () {
      PurchaseBusinessService.approveSignQualification(this.form).then(res => {
        if (res && res.code === '0') {
          successMessage('审核结果提交成功');
          this.$router.go(-1);
        } else if (res && res.reason){
          errorMessage(res.reason);
        } else {
          successMessage('审核结果提交失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('审核结果提交失败');
        }
      });
    },
    // 查询详情
    getSignUserInfo () {
      PurchaseBusinessService.getSignUserInfo(this.form.id).then(res => {
        if (res && res.code === '0') {
          this.auditApplyInfo = res.data;
          if (this.auditApplyInfo.legalFront && this.auditApplyInfo.legalBack) {
            this.legalImgArr = [...this.auditApplyInfo.legalFront, ...this.auditApplyInfo.legalBack];
          }
          if (this.auditApplyInfo.assignorFront && this.auditApplyInfo.assignorBack) {
            this.assignorImgArr = [...this.auditApplyInfo.assignorFront, ...this.auditApplyInfo.assignorBack];
          }
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.approveSignQualification();
        }
      });
    }
  }
};
